module.exports = __webpack_public_path__ + "static/media/fe3h.9a512e7f.png";